import React from "react";

const TicketsPagination = ({ queries, onPageChange, onPerPageChange }) => {
  const { page = 1, per_page = 10, total = 0 } = queries;
  const totalPages = Math.ceil(total / per_page);

  const handlePrevious = () => {
    if (page > 1) {
      onPageChange(page - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      onPageChange(page + 1);
    }
  };

  const handlePageSelect = (newPage) => {
    onPageChange(newPage);
  };

  const handlePerPageChange = (e) => {
    onPerPageChange(parseInt(e.target.value));
  };

  const startItem = (page - 1) * per_page + 1;
  const endItem = Math.min(page * per_page, total);

  return (
    <div className="bg-white px-4 py-3 border border-gray-200 rounded-b-md shadow-lg">
      <div className="flex items-center justify-between">
        <div className="flex items-center text-sm text-gray-700">
          <span>Show</span>
          <select
            value={per_page}
            onChange={handlePerPageChange}
            className="mx-2 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span>entries</span>
        </div>

        <div className="flex items-center text-sm text-gray-700">
          <span>
            Showing {startItem} to {endItem} of {total} entries
          </span>
        </div>

        <div className="flex items-center space-x-1">
          <button
            onClick={handlePrevious}
            disabled={page <= 1}
            className="px-3 py-1 text-sm text-gray-700 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Previous
          </button>

          {/* Page numbers */}
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (page <= 3) {
              pageNum = i + 1;
            } else if (page >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = page - 2 + i;
            }

            return (
              <button
                key={pageNum}
                onClick={() => handlePageSelect(pageNum)}
                className={`px-3 py-1 text-sm border border-gray-300 rounded ${
                  page === pageNum
                    ? "bg-orange-500 text-white border-orange-500"
                    : "text-gray-700 hover:bg-gray-50"
                }`}
              >
                {pageNum}
              </button>
            );
          })}

          <button
            onClick={handleNext}
            disabled={page >= totalPages}
            className="px-3 py-1 text-sm text-gray-700 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketsPagination;
